import React from "react";
import styles from "./Heading.module.scss";

function Heading({ level, fw, children }) {
  let classes = styles.heading;

  if (fw === 500) {
    classes += ` ${styles.fw500}`;
  }
  if (fw === 600) {
    classes += ` ${styles.fw600}`;
  }
  if (fw === 700) {
    classes += ` ${styles.fw700}`;
  }

  if (level === "h1") {
    return <h1 className={classes}>{children}</h1>;
  } else if (level === "h3") {
    return <h3 className={classes}>{children}</h3>;
  } else if (level === "h4") {
    return <h4 className={classes}>{children}</h4>;
  } else if (level === "h5") {
    return <h5 className={classes}>{children}</h5>;
  } else return null;
}

export default Heading;
